import {DatePicker, Select} from 'antd';
import dayjs, {Dayjs} from 'dayjs';
import {ReactElement} from 'react';

import {Locale} from '../../../../provider/locale/locale';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {LangKeyType} from '../../../../provider/locale/translation/type';
import {PublicationListFilterType} from '../../../../service/publication/publication-filter-type';

import * as styles from './publication-list-filter.scss';

const {RangePicker} = DatePicker;

type StatusOptionType = {
    value: string;
    langKey: LangKeyType;
};

type PropsType = {
    filter: PublicationListFilterType;
    statusOptions: Array<StatusOptionType>;
    onChange: (filter: PublicationListFilterType) => void;
};

export function PublicationListFilter(props: PropsType): ReactElement {
    const {filter, statusOptions, onChange} = props;

    const {getLocalizedString} = useLocale();

    const rangeValue: [Dayjs | null, Dayjs | null] = [
        filter.createdAtGte ? dayjs(filter.createdAtGte) : null,
        filter.createdAtLte ? dayjs(filter.createdAtLte) : null,
    ];

    return (
        <div className={styles.PublicationListFilter}>
            <Select<Array<string>>
                allowClear
                className={styles.PublicationListFilter_status}
                mode="multiple"
                onChange={(statuses) => onChange({...filter, statuses})}
                optionFilterProp="label"
                options={statusOptions.map((option) => ({
                    value: option.value,
                    label: getLocalizedString(option.langKey),
                }))}
                placeholder={<Locale stringKey="POSTS__FILTER_FORM__INPUT__STATUS__PLACEHOLDER" />}
                value={filter.statuses}
            />

            <RangePicker
                format="YYYY-MM-DD"
                onChange={(dates) =>
                    onChange({
                        ...filter,
                        createdAtGte: dates?.[0] ? dates[0].startOf('day').toISOString() : null,
                        createdAtLte: dates?.[1] ? dates[1].endOf('day').toISOString() : null,
                    })
                }
                value={rangeValue}
            />
        </div>
    );
}
